export default __webpack_public_path__ + "static/media/BecomeWizard.341ce66a.png";